import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  bannerContainer: {
    alignItems: 'center',
    backgroundColor: colors.warning.softSunflower,
    borderRadius: scale(8),
    flexDirection: 'row',
    marginHorizontal: scale(16),
    marginVertical: scale(16),
    paddingHorizontal: scale(12),
    paddingVertical: scale(8),
    shadowColor: colors.neutral.charcoal,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  textContainer: {
    marginLeft: scale(8),
    flex: 1,
  },
});

export default styles;
